// extracted by mini-css-extract-plugin
export default {"dashboard-header":"style_dashboard-header__NzMhV","dashboard-settings":"style_dashboard-settings__8ah48","dashboard-banner":"style_dashboard-banner__GOm0p"};